module.exports = __webpack_public_path__ + "img/ezgif.com-gif-maker-E.dc2ada87.png";